module.exports = __webpack_public_path__ + "img/tktPass.e0bd63ba.png";